import React from "react";
import { PropTypes } from "prop-types";
import { HomePageLayout } from "application/home/components";
import { Category, CategoryPageHeader } from "application/categories/components";
import { MrbPageHeader } from "mrb/components/layout";
import { defaultTemplate } from "common/hoc";

function PodcastsPageTemplate({ podcastsViewStore, t }) {
    return (
        <HomePageLayout store={podcastsViewStore} t={t}>
            <div>
                <MrbPageHeader classNameExtend="c-page__header--secondary">
                    <CategoryPageHeader store={podcastsViewStore} t={t} />
                </MrbPageHeader>
                <Category store={podcastsViewStore} t={t} />
            </div>
        </HomePageLayout>
    );
}

PodcastsPageTemplate.propTypes = {
    podcastsViewStore: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default defaultTemplate(PodcastsPageTemplate);
